<template>
    <div class="scheduling-home-page-component-container">
        <div class="component-wrapper">
            <AppHeader />
            <div class="scheduling-home-page-container scroll-bar">
                <div v-if="loadingPage" class="spinner-container">
                    <div class="spinner">
                        <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image">
                    </div>
                </div>

                <div v-if="(successLoadingClientEventsPage && !loadingPage) || (!loadingPage && !successLoadingClientEventsPage && selectedEvent)" class="back-btn-info-btn-container">
                    <div class="back-btn-container" @click="goBack">
                        <img src="../../assets/icons/long_back_arrow.png" alt="Arrow image">
                    </div>
                    <div class="info-btn-container" @click="showPopupMsg('warning', 'maxRescheduleLimitPerMeeting')">
                        <img src="../../assets/icons/question_mark.png" alt="Info image">
                    </div>
                </div>

                <ClientEventsPage v-if="successLoadingClientEventsPage && !loadingPage" :clientEventsObj="clientEventsObj"
                    :extractTimeFromDate="extractTimeFromDate" :getClientEvents="getClientEvents" 
                    :getDayMonthAndWeekday="getDayMonthAndWeekday" :showPopupMsg="showPopupMsg" :selectEvent="selectEvent" 
                    :selectedEventIndex="selectedEventIndex" :showSelectedEventPageHandle="showSelectedEventPageHandle" :IsPartnerEventActive="IsPartnerEventActive"
                />

                <SelectedEventPage v-if="!loadingPage && !successLoadingClientEventsPage && showSelectedEventPage" 
                    :allClientEvents="allClientEvents" :selectedEvent="selectedEvent" :showSaveBtn="showSaveBtn" 
                    :extractTimeFromDate="extractTimeFromDate" :availabeTimeSlots="availabeTimeSlots"
                    :getDayMonthAndWeekday="getDayMonthAndWeekday" 
                    :weeksRangeOfSelectedDate="weeksRangeOfSelectedDate" :toggoleDisplayingSaveBtnHandle="toggoleDisplayingSaveBtnHandle"
                    :clientEventsObj="clientEventsObj" :updatePopupMsgObj="updatePopupMsgObj" :rescheduleEvent="rescheduleEvent" :rescheduleEventData="rescheduleEventData" 
                    :updateRescheduleEventDataObject="updateRescheduleEventDataObject"
                />

                <div v-if="failedLoadingPage" class="fialed-loading-page-container">
                    <div class="info-text-container">
                        <p class="info-text">
                            {{ $t('oops_try_again_or_contact_trainer') }}
                        </p>
                    </div>
                    <div class="reload-btn-container">
                        <div class="reload-btn" @click="reloadPage">{{ $t('reload') }}</div>
                    </div>
                </div>

            </div>
            <AppFooter />
        </div>
        <!-- <ConfirmMsgPopupComponent v-if="showConfirmPopupMsg"
            :eventActionType="eventActionType" :selectedEventInfo="selectedEventInfo"
            :selectedEventIndex="selectedEventIndex" :deleteEvent="deleteEvent"
            :closeConfirmPopupMsgHandle="closeConfirmPopupMsgHandle" :loadingEventAction="loadingEventAction"
            :showEventActionMsg="showEventActionMsg" :eventActionMsg="eventActionMsg"
            :rescheduleEvent="rescheduleEvent"
        /> -->

        <PopupMsg v-if="popupObj" :popupObj="popupObj" :closePopupMsg="closePopupMsg" :loadingPopupMsg="loadingPopupMsg" 
            :partnerEventId="partnerEventId" :togglePartnerSelection="togglePartnerSelection"
            :updateCancellationReason="updateCancellationReason" :noCancellationReasonSelected="noCancellationReasonSelected"
        />
    </div>
</template>

<script>
import AppHeader from '../home/AppHeader.vue';
import AppFooter from '../home/AppFooter.vue';
import ClientEventsPage from './ClientEventsPage.vue';
import SelectedEventPage from './SelectedEventPage.vue';
import PopupMsg from './PopupMsg.vue';
// import ConfirmMsgPopupComponent from './ConfirmMsgPopup.vue';
export default {
    name: 'SchedulingHomePage',
    data() {
        return {
            loadingPage: true,
            successLoadingClientEventsPage: false,
            failedLoadingPage: false,
            clientEventsObj: null,
            allClientEvents: [],
            startDateTimePrevNextSessions: false,
            selectedEventIndex: null,
            IsPartnerEventActive: false,
            // selectedPartnerEventId: null,
            popupObj: null,
            loadingPopupMsg: false,
            partnerEventId: null,
            showSelectedEventPage: false,
            selectedEvent: null,
            availabeTimeSlots: [],
            showSaveBtn: false,
            cancellationReasonObj: null,
            noCancellationReasonSelected: false,
            noEventsFounded: false,

            rescheduleEventData: null,
            
            weeksRangeOfSelectedDate: [],
            
            showEventActionMsg: false,
            eventActionMsg: '',
            msgColor: '',
            
            successLoadingAvailableTileSlots: false,
            selectedTimeSlotGroupIndex: null,
            selectedTimeSlotIndex: null,
            showConfirmPopupMsg: false,
            eventActionType: '',
            selectedEventInfo: false,
            loadingEventAction: false,
        };
    },
    components: {
        AppHeader,
        AppFooter,
        PopupMsg,
        // ConfirmMsgPopupComponent,
        ClientEventsPage,
        SelectedEventPage,
    },
    methods: {
        parseDateTime: function(dateTime) {
            // Create a Date object
            const date = new Date(dateTime);

            // Get the day name using toLocaleDateString
            const dayName = date.toLocaleDateString('en-US', { weekday: 'long' });

            // Extract the date part
            const datePart = date.toISOString().split('T')[0];

            // Extract the time part, stripping out seconds and timezone for simplicity
            const timePart = date.toISOString().split('T')[1].substring(0, 5);

            const dateInfo = {
                dayName: dayName,
                date: datePart,
                time: timePart,
            };

            return dateInfo;
        },
        extractTimeFromDate: function(dateString) {
            // Create a Date object from the date string
            const date = new Date(dateString);

            // Extract the hours and minutes
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            // Combine hours and minutes to get the time
            const time = `${hours}:${minutes}`;

            return time;
        },
        extractDate: function(dateTimeString) {
            // Split the string at the 'T' character and return the first part (the date)
            const [date] = dateTimeString.split('T');
            return date;
        },
        // getDayName: function (dateString) {
        //     let selectedAppLanguage = this.$store.selectedAppLanguage;
        //     const date = new Date(dateString);
        //     let language;

        //     // Determine the language to use
        //     if (selectedAppLanguage === "en" || selectedAppLanguage === "nl") {
        //         language = selectedAppLanguage;
        //     } else {
        //         language = "en"; // Default to English if the language is not "en" or "nl"
        //     }

        //     // Get the day name using Intl.DateTimeFormat
        //     const dayName = new Intl.DateTimeFormat(language, { weekday: 'long' }).format(date);

        //     const formattedDayName = dayName.charAt(0).toUpperCase() + dayName.slice(1);
            
        //     // Return the first three letters of the day name
        //     return formattedDayName.slice(0, 2);
        // },
        // getDayAndMonthAbbreviation: function (dateString) {
        //     // console.log(dateString);
        //     let locale = 'en-US';

        //     // Set the locale based on the app language to get the month name in the same language as the app
        //     let selectedAppLanguage = this.$store.selectedAppLanguage;
        //     if (selectedAppLanguage === 'nl') {
        //         locale = 'nl-NL';
        //     }

        //     // Create a Date object from the given ISO date string
        //     const date = new Date(dateString);

        //     // Get the day number
        //     const dayNumber = date.getDate();
        //     // console.log(dayNumber);

        //     // Get the first two letters of the month
        //     const monthAbbreviation = date.toLocaleDateString(locale, {month: 'short'}).slice(0, 3);
        //     // console.log(monthAbbreviation);

        //     // Return an object with the day and month abbreviation
        //     return {
        //         dayNumber: dayNumber,
        //         monthAbbreviation: monthAbbreviation
        //     };
        // },
        getDayMonthAndWeekday: function (dateString) {
            const locale = 'en-US';
            const date = new Date(dateString);

            return {
                dayNumber: date.getDate(),
                monthName: date.toLocaleDateString(locale, { month: 'long' }),
                dayName: date.toLocaleDateString(locale, { weekday: 'long' })
            };
        },
        getWeeksRangeOfSelectedDate: function (dateString) {
            // Helper function to get the start of the week (Monday)
            function getStartOfWeek(date) {
                const dayOfWeek = date.getDay(); // Get the current day of the week (0 = Sunday, 6 = Saturday)
                const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Calculate the difference to get to Monday
                const startOfWeek = new Date(date);
                startOfWeek.setDate(date.getDate() + diff);
                return startOfWeek;
            }
        
            // Helper function to format a date object to "YYYY-MM-DD"
            function formatDate(date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based in JS
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            }
        
            // Helper function to generate a week object
            function generateWeekObject(startOfWeekDate) {
                const weekObject = {
                    weekNumber: getWeekNumber(startOfWeekDate),
                    dates: []
                };
            
                for (let i = 0; i < 7; i++) {
                    const currentDay = new Date(startOfWeekDate);
                    currentDay.setDate(startOfWeekDate.getDate() + i);
                    weekObject.dates.push({ date: formatDate(currentDay) });
                }
            
                return weekObject;
            }
        
            // Helper function to get the ISO week number
            function getWeekNumber(date) {
                const startOfYear = new Date(date.getFullYear(), 0, 1);
                const diff = (date - startOfYear + (startOfYear.getTimezoneOffset() - date.getTimezoneOffset()) * 60000) / 86400000;
                return Math.ceil((diff + startOfYear.getDay() + 1) / 7);
            }
        
            // Create a Date object from the input string
            const givenDate = new Date(dateString);
        
            // Get start of the week for the given date, previous week, and next week
            const currentWeekStart = getStartOfWeek(givenDate);
            const previousWeekStart = new Date(currentWeekStart);
            previousWeekStart.setDate(currentWeekStart.getDate() - 7);
            const nextWeekStart = new Date(currentWeekStart);
            nextWeekStart.setDate(currentWeekStart.getDate() + 7);
        
            // Generate week objects for previous, current, and next week
            const previousWeek = generateWeekObject(previousWeekStart);
            const currentWeek = generateWeekObject(currentWeekStart);
            const nextWeek = generateWeekObject(nextWeekStart);
        
            // Return an array of 3 week objects
            return [previousWeek, currentWeek, nextWeek];
        },
        getWeekNumber: function (dateString) {
            const date = new Date(dateString);

            // Set the date to the nearest Thursday (ISO 8601 week starts on Monday)
            const day = date.getUTCDay() || 7; // getUTCDay returns 0 for Sunday, we need 7 for Sunday
            date.setUTCDate(date.getUTCDate() + 4 - day);

            // Calculate the first day of the year
            const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));

            // Calculate full weeks to nearest Thursday
            const weekNumber = Math.ceil((((date - yearStart) / 86400000) + 1) / 7);

            // console.log("weekNumber: " + weekNumber);

            return weekNumber;
        },
        selectEvent: function (eventIndex) {
            // console.log(eventIndex);
            const selectedEvent = this.clientEventsObj.events[eventIndex];
            // console.log(selectedEvent);
            // console.log("selectedEvent.No_sessions_possible: " + selectedEvent.No_sessions_possible);
            if (selectedEvent.No_sessions_possible) {
                // The event is not available for rescheduling.
                this.popupObj = {
                    popupType: 'warning',
                    title: 'no_training_possible',
                    text: 'reschedule_not_possible',
                    actionBtn: false,
                };
                this.selectedEventIndex = null;
            }
            else {
                if (selectedEvent.Cancelled) {
                    if (Number(this.clientEventsObj.maxRescheduleLimitPerMeeting) < Number(selectedEvent.Reschedule_Count)) {
                        // The cancelled event is not allowed to be rescheduled because the client reach the maximum reschedule limit for this event.
                        this.popupObj = {
                            popupType: 'warning',
                            title: 'your_trainings',
                            text: 'max_reschedule_attempts_reached',
                            actionBtn: false,
                        };
                        this.selectedEventIndex = null;
                    }
                    else {
                        this.selectedEventIndex = eventIndex;
                        this.selectedEvent = selectedEvent;

                        if (selectedEvent.Meeting_Type !== 'DUO') {
                            /*  The event type is SOLO or FLEX.
                                So the client is allowed to reschedule the cancelled event.So he will be navigated directly to the selected event page to see the free time slots.
                            */
                            
                            //    console.log(this.selectedEvent.Reschedule_Count);
                            //    console.log(this.clientEventsObj.maxRescheduleLimitPerMeeting);

                            this.showSelectedEventPageHandle(eventIndex);
                            //    this.showSelectedEventPageHandle(eventIndex);
                            //    console.log("Go to selected event page...");
                        }
                        else {
                            // The event type is DUO. So check if the client should get 2 buttons "Reactivate" and "Reschedule". 
                            // The button "Reactivate" is to reactivate the training in the same date time without going to the available time slot page, and the button "Reschedule" to reschedule the training by navigating directly to the available time slot page. 
                            // The client will get the "Reactivate" button if his partner did not cancel the training session, but if the partner also canceled the training session, the client will be navigated directly to the available time slot page.

                            let partnerEvent;
                            // let selectedPartnerEventId = null;
                            if (this.clientEventsObj.partnerData) {
                                partnerEvent = this.clientEventsObj.partnerData.events.find((partnerEvent) => partnerEvent.Start_DateTime == selectedEvent.Start_DateTime);
                                // console.log("partnerEvent:");
                                // console.log(partnerEvent);
                                if (partnerEvent) {
                                    if (partnerEvent.Cancelled) {
                                        if (this.IsPartnerEventActive) {
                                            this.IsPartnerEventActive = false;
                                        }
                                        this.showSelectedEventPageHandle(eventIndex);
                                    }
                                    else {
                                        this.IsPartnerEventActive = true;
                                    }
                                }
                                else {
                                    this.showSelectedEventPageHandle(eventIndex);
                                }
                            }
                            // console.log("this.selectedPartnerEventId: " + this.selectedPartnerEventId);
                        }
                    }
                }
                else {
                    this.selectedEventIndex = eventIndex;
                    this.selectedEvent = selectedEvent;
                }
            }
            // else if (selectedEvent.Cancelled && !selectedEvent.No_sessions_possible) {
            //     if (Number(this.clientEventsObj.maxRescheduleLimitPerMeeting) < Number(this.selectedEvent.Reschedule_Count)) {
            //         // The cancelled event is not allowed to be rescheduled because the client reach the maximum reschedule limit for this event.
            //         this.popupObj = {
            //             popupType: 'warning',
            //             title: 'your_trainings',
            //             text: 'max_reschedule_attempts_reached',
            //             actionBtn: false,
            //         };
            //         this.selectedEventIndex = null;
            //     }
            //     else {
            //         this.selectedEventIndex = eventIndex;
            //         this.selectedEvent = this.clientEventsObj.events[eventIndex];
            //         if (selectedEvent.Meeting_Type !== 'DUO') {
            //             /*  The event type is SOLO or FLEX.
            //                 So the client is allowed to reschedule the cancelled event.
            //                 Go to the selected event page.
            //             */
                        
            //             //    console.log(this.selectedEvent.Reschedule_Count);
            //             //    console.log(this.clientEventsObj.maxRescheduleLimitPerMeeting);

            //             this.showSelectedEventPageHandle(eventIndex);
            //             //    this.showSelectedEventPageHandle(eventIndex);
            //             //    console.log("Go to selected event page...");
            //         }
            //         else {
            //             //     // The event type is DUO. So do not do anything
            //             //     // console.log("Event type is DUO...");
            //             //     this.popupObj = {
            //             //         popupType: 'warning',
            //             //         title: 'your_trainings',
            //             //         text: 'canceled_training_cannot_be_rescheduled',
            //             //         actionBtn: false,
            //             //     };
            //             //     this.selectedEventIndex = null;
            //             let partnerEvent;
            //             // let selectedPartnerEventId = null;
            //             if (this.clientEventsObj.partnerData) {
            //                 partnerEvent = this.clientEventsObj.partnerData.events.find((partnerEvent) => partnerEvent.Start_DateTime == selectedEvent.Start_DateTime);
            //                 console.log("partnerEvent: " + partnerEvent);
            //                 if (partnerEvent) {
            //                     this.selectedPartnerEventId = partnerEvent.id;
            //                 }
            //             }
            //         }
            //     }
                
            // }
            // else {
            //     this.selectedEventIndex = eventIndex;
            // }

            // console.log("partnerEventId: " + this.partnerEventId);
            // console.log(this.selectedEventIndex);
        },
        getClientEvents: async function() {
            this.loadingPage = true;
            this.successLoadingClientEventsPage = false;
            try {
                const data = {
                    email: this.$store.user.email,
                    zohoId: this.$store.user.zohoId,
                    token: this.$store.user.token,
                    studioTimeZone: this.$store.user.studiosInfo[0].studioTimeZone,
                };

                const clientEventsResponse = await fetch('/api/calendar/getEvents', {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json; charset=UTF-8',
                    },
                    body: JSON.stringify(data),
                });

                const clientEventsResponseJson = await clientEventsResponse.json();

                // console.log(clientEventsResponseJson);

                if (!clientEventsResponseJson.status) {
                    if (clientEventsResponseJson.invalidToken) {
                        this.$store.showErrorPopup = true;
                        this.$store.errorPopupTitle = 'logout';
                        this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                        this.$store.mustLogOut = true;
                    }
                    else {
                        this.failedLoadingPage = true;
                    }
                }
                else {
                    this.clientEventsObj = clientEventsResponseJson.data;
                    this.allClientEvents = clientEventsResponseJson.allData;
                    // console.log(this.allClientEvents);
                    // console.log(clientEventsResponseJson.data);
                    // console.log(clientEventsResponseJson);
                    this.startDateTimePrevNextSessions = clientEventsResponseJson.data.startDateTimePrevNextSessions;
                    this.successLoadingClientEventsPage = true;
                }
                this.loadingPage = false;
            }
            catch(err) {
                console.log("Error getting client events...");
                console.log(err);
                this.failedLoadingPage = true;
                this.loadingPage = false;
            }
        },
        reloadPage: async function () {
            this.loadingPage = true;
            this.failedLoadingPage = false;
            this.noEventsFounded = false;
            this.successLoadingClientEventsPage = false;
            await this.getClientEvents();
        },
        showPopupMsg: function (popupType, actionType) {
            this.popupObj = null;
            if (popupType == 'warning') {
                if (actionType == 'maxRescheduleLimitPerMeeting') {
                    this.popupObj = {
                        popupType: popupType,
                        // popupAction: 'maxRescheduleLimitPerMeeting',
                        title: 'your_trainings',
                        text: 'training_session_reschedule_limit_with_count',
                        actionBtn: false,
                        rescheduleLimit: this.clientEventsObj.maxRescheduleLimitPerMeeting,
                    };
                }
                else if (actionType == 'timeNotAvailable') {
                    this.popupObj = {
                        popupType: popupType,
                        // popupAction: 'timeNotAvailable',
                        title: 'not_available',
                        text: 'time_slot_unavailable_retry',
                        actionBtn: false,
                    };
                }
            }
            else if (popupType == 'confirm') {
                // if (actionType == 'continueWithoutSave') {
                //     this.popupObj = {
                //         popupType: popupType,
                //         title: 'not_saved',
                //         text: 'continue_without_save',
                //         // actionBtn: this.test,
                //     };
                // }
                // else {
                    const selectedEvent = this.clientEventsObj.events[this.selectedEventIndex];
                    const selectedClietEventId = selectedEvent.id;
                    if (actionType == 'delete') {
                        // let selectReasonPopupObj = null;
                        if (selectedEvent.Meeting_Type != 'DUO') {
                            // selectReasonPopupObj = {
                            //     popupType: popupType,
                            //     title: 'reason_for_cancellation',
                            //     actionBtn: () => this.deleteEvent(selectedClietEventId),
                            //     // actionBtn: () => this.updateCancellationReason(),
                            // };

                            this.popupObj = {
                                popupType: popupType,
                                title: 'confirm_cancellation',
                                text: 'cancel_training_with_reschedule_option',
                                actionBtn: () => this.deleteEvent(selectedClietEventId),
                            };
                        }
                        else {
                            // Get the partner event that related to the selected client's event.
                            // console.log(selectedEvent);
                            // console.log(selectedClietEventId);
                            this.partnerEventId = null;
                            let partnerEvent;
                            let selectedPartnerEventId = null;
                            if (this.clientEventsObj.partnerData) {
                                partnerEvent = this.clientEventsObj.partnerData.events.find((partnerEvent) => partnerEvent.Start_DateTime == selectedEvent.Start_DateTime);
                                // console.log(partnerEvent);
                                if (partnerEvent) {
                                    selectedPartnerEventId = partnerEvent.id;
                                }
                            }

                            // console.log(this.clientEventsObj.partnerData);

                            this.popupObj = {
                                popupType: popupType,
                                title: 'confirm_cancellation',
                                text: 'cancel_training_for',
                                actionBtn: () => this.deleteEvent(selectedClietEventId, this.partnerEventId),
                                partnerEventId: selectedPartnerEventId,
                                clientName: this.clientEventsObj.clientName,
                                partnerName: this.clientEventsObj.partnerData ? this.clientEventsObj.partnerData.name : null,
                                partnerEventCancelled: partnerEvent ? partnerEvent.Cancelled : true,
                            }
                            // console.log(this.popupObj);
                        }
                    }
                    if (actionType == 'reactivate') {
                        let partnerEvent;
                        let selectedPartnerEventId = null;
                        if (this.clientEventsObj.partnerData) {
                            partnerEvent = this.clientEventsObj.partnerData.events.find((partnerEvent) => partnerEvent.Start_DateTime == selectedEvent.Start_DateTime);
                            // console.log(partnerEvent);
                            if (partnerEvent) {
                                selectedPartnerEventId = partnerEvent.id;
                            }
                        }
                        const rescheuleEventDataObj = {
                            ownerEventId: this.selectedEvent.id,
                            clientName: this.clientEventsObj.clientName,
                            newStartDateTime: this.selectedEvent.Start_DateTime,
                            newEndDateTime: this.selectedEvent.End_DateTime,
                            partnerEventId: selectedPartnerEventId,
                            prevSessionDate: this.clientEventsObj.startDateTimePrevNextSessions.startDateTimePreviousSession,
                            nextSessionDate: this.clientEventsObj.startDateTimePrevNextSessions.startDateTimeOf9thNextSession,
                            studioTimeZone: this.$store.user.studiosInfo[0].studioTimeZone,
                            reactiveCancelledPartnerEvent: false,
                            reactivateClientCancelledEvent: true,
                        };
                        this.popupObj = {
                            popupType: popupType,
                            title: 'confirm_reactivation',
                            text: 'confirm_reactivate_cancelled_time_slot',
                            actionBtn: () => this.rescheduleEvent(rescheuleEventDataObj),
                            // IsPartnerEventActive: this.IsPartnerEventActive,
                        };
                    }
                // }
            }
        },
        closePopupMsg: function () {
            // console.log(this.popupObj);
            this.popupObj = null;
            // Reset the value of noCancellationReasonSelected to the default value.
            this.noCancellationReasonSelected = false;
            if (this.partnerEventId) {
                this.partnerEventId = null;
            }
        },
        deleteEvent: async function (clientEventId, partnerEventId) {
            // console.log("clientEventId: " + clientEventId);
            // console.log("partnerEventId: " + partnerEventId);
            this.loadingPopupMsg = true;
            this.noCancellationReasonSelected = false;

            const localStorageUser = JSON.parse(localStorage.getItem('user'));
            if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
                this.$store.showErrorPopup = true;
                this.$store.errorPopupTitle = 'logout';
                this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                this.$store.mustLogOut = true;
            }
            else {
                // Check if the client select a cancellation reason or not.
                if (!this.cancellationReasonObj || (this.cancellationReasonObj && !this.cancellationReasonObj.reason)) {
                    // The client does not selected a cancellation reason.
                    this.noCancellationReasonSelected = true;
                    this.loadingPopupMsg = false;
                }
                else {
                    // The client selected a cancellation reason.
                    try {
                        // console.log(clientEventId);
                        // console.log(partnerEventId);
                        
                        const { email, token } = localStorageUser;
                        const cancellationReason = `
                            ${this.$t('cancellation_reason')}: ${(this.cancellationReasonObj.reason).toString()}. \n${this.cancellationReasonObj.message ? this.$t('message') + ":" + (this.cancellationReasonObj.message).toString() : ""}
                        `;

                        const data = {
                            email: email,
                            token: token,
                            clientEventId: clientEventId,
                            clientName: this.clientEventsObj.clientName,
                            partnerEventId: partnerEventId,
                            cancellationReasonObj: cancellationReason,
                        };

                        // console.log(data);

                        const deleteEventResponse = await fetch('../../api/calendar/deleteEvent', {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json; charset=UTF-8',
                            },
                            body: JSON.stringify(data),
                        });

                        // console.log(deleteEventResponse);

                        const deleteEventResponseJson = await deleteEventResponse.json();

                        // console.log(deleteEventResponseJson);

                        if (!deleteEventResponseJson.status) {
                            // console.log("Can not delete the event!");
                            // console.log(deleteEventResponseJson.message);
                            if (deleteEventResponseJson.invalidToken) {
                                this.$store.showErrorPopup = true;
                                this.$store.errorPopupTitle = 'logout';
                                this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                                this.$store.mustLogOut = true;
                            }
                            else {
                                this.popupObj = {
                                    popupType: 'error',
                                    title: 'unfortunately',
                                    text: deleteEventResponseJson.message,
                                    actionBtn: false,
                                };
                            }
                        }
                        else {
                            this.clientEventsObj.events[this.selectedEventIndex].Cancelled = true;
                            this.popupObj = null;
                            // console.log("this.selectedPartnerEventId from deleteEvent function: " + this.selectedPartnerEventId);
                            // console.log("partnerEventId from deleteEvent function: " + partnerEventId);

                            if (this.clientEventsObj.events[this.selectedEventIndex].Meeting_Type === 'DUO') {
                                if (partnerEventId) {
                                    this.selectedPartnerEventId = partnerEventId;
                                }
                                else {
                                    let partnerEvent;
                                    if (this.clientEventsObj.partnerData) {
                                        partnerEvent = this.clientEventsObj.partnerData.events.find((partnerEvent) => partnerEvent.Start_DateTime == this.clientEventsObj.events[this.selectedEventIndex].Start_DateTime);
                                        // console.log("partnerEvent in deleteEvent function: " + partnerEvent);
                                        if (partnerEvent) {
                                            this.selectedPartnerEventId = partnerEvent.id;
                                        }
                                    }
                                }

                                if (partnerEventId && this.clientEventsObj.partnerData) {
                                    const partnerEventIndex = this.clientEventsObj.partnerData.events.findIndex(event => event.id === partnerEventId);
                                    this.clientEventsObj.partnerData.events[partnerEventIndex].Cancelled = true;
                                    this.IsPartnerEventActive = false;
                                }
                                // const partnerEventIndex = this.clientEventsObj.partnerData.events.findIndex((partnerEvent) => partnerEvent.id == partnerEventId);
                                // if (partnerEventIndex !== -1) {
                                //     this.clientEventsObj.partnerData.events[partnerEventIndex].Cancelled = true;
                                // }

                            }

                            // this.popupObj = {
                            //     popupType: 'info',
                            //     title: 'success',
                            //     text: 'training_canceled_successfully',
                            //     actionBtn: false,
                            // };
                        }
                        if (this.partnerEventId) {
                            this.partnerEventId = null;
                        }
                        this.cancellationReasonObj = null;
                        this.loadingPopupMsg = false;
                    }
                    catch(err) {
                        console.log(err);
                        this.loadingPopupMsg = false;
                        this.popupObj = {
                            popupType: 'error',
                            title: 'unfortunately',
                            text: 'something_went_wrong_try_again',
                            actionBtn: false,
                        };
                    }
                }
            }
        },
        rescheduleEvent: async function(data) {
            // console.log("Rescheduling...");
            // console.log(data);
            this.loadingPopupMsg = true;
            const localStorageUser = JSON.parse(localStorage.getItem('user'));
            if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
                this.$store.showErrorPopup = true;
                this.$store.errorPopupTitle = 'logout';
                this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                this.$store.mustLogOut = true;
            }
            else {
                try {
                    const { email, token } = localStorageUser;
                    // const ownerEventId = this.clientEvents[this.selectedEventIndex].id;
                    // const newStartDateTime = this.availabeTimeSlots[this.selectedTimeSlotGroupIndex].availableSlots[this.selectedTimeSlotIndex].Start_DateTime;
                    // const newEndDateTime = this.availabeTimeSlots[this.selectedTimeSlotGroupIndex].availableSlots[this.selectedTimeSlotIndex].End_DateTime;
                    // const partnerEventId = this.partnerEventId;

                    // const data = {
                    //     email: email,
                    //     token: token,
                    //     ownerEventId: ownerEventId,
                    //     newStartDateTime: newStartDateTime,
                    //     newEndDateTime: newEndDateTime,
                    //     partnerEventId: partnerEventId,
                    // }

                    data.email = email;
                    data.token = token;
                    data.zohoId = this.$store.user.zohoId;

                    // console.log(data);

                    const rescheduleEventResponse = await fetch('../../api/calendar/rescheduleEvent', {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json; charset=UTF-8',
                        },
                        body: JSON.stringify(data),
                    });

                    const rescheduleEventResponseJson = await rescheduleEventResponse.json();

                    // console.log(rescheduleEventResponseJson);

                    if (!rescheduleEventResponseJson.status) {
                        if (rescheduleEventResponseJson.invalidToken) {
                            this.$store.showErrorPopup = true;
                            this.$store.errorPopupTitle = 'logout';
                            this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                            this.$store.mustLogOut = true;
                        }
                        else if (rescheduleEventResponseJson.noSessionsPossible) {
                            this.popupObj = {
                                popupType: 'warning',
                                title: 'no_training_possible',
                                text: 'reschedule_not_possible',
                                actionBtn: false,
                            };
                        }
                        else {
                            this.popupObj = {
                                popupType: rescheduleEventResponseJson.timeNoLongerAvailable ? 'info' : 'error',
                                title: rescheduleEventResponseJson.timeNoLongerAvailable ? 'not_available' : 'unfortunately',
                                text: rescheduleEventResponseJson.message,
                                actionBtn: false,
                            };
                        }
                        this.loadingPopupMsg = false;
                    }
                    else {
                        // this.popupObj = {
                        //     popupType: 'info',
                        //     title: 'success',
                        //     text: 'training_rescheduled_success',
                        //     actionBtn: false,
                        //     reloadPage: true,
                        // };

                        this.clientEventsObj.events[this.selectedEventIndex] = rescheduleEventResponseJson.clientEvent;
                        this.showSelectedEventPage = false;
                        this.loadingPopupMsg = false;
                        this.popupObj = null;
                        this.selectedEventIndex = null;
                        this.selectedEvent = null;
                        this.showSaveBtn = false;
                        if (this.partnerEventId) {
                            this.partnerEventId = null;
                            if (this.rescheduleEventData) {
                                this.rescheduleEventData.reactiveCancelledPartnerEvent = false;
                            }
                        }
                        await this.getClientEvents();
                    }
                }
                catch(err) {
                    console.log("Error rescheduling event...");
                    console.log(err);
                    this.loadingPopupMsg = false;
                    this.popupObj = {
                        popupType: 'error',
                        title: 'unfortunately',
                        text: 'something_went_wrong_try_again',
                        actionBtn: false,
                    }
                }
            }
        },
        togglePartnerSelection: function (partnerEventId) {
            // console.log("partnerEventId: " + partnerEventId);
            if (this.partnerEventId) {
                this.partnerEventId = null;
                if (this.rescheduleEventData) {
                    this.rescheduleEventData.reactiveCancelledPartnerEvent = false;
                }
            }
            else {
                this.partnerEventId = partnerEventId;
                if (this.rescheduleEventData) {
                    this.rescheduleEventData.reactiveCancelledPartnerEvent = true;
                }
            }
            // console.log(this.rescheduleEventData);
        },
        showSelectedEventPageHandle: async function (eventIndex) {
            this.loadingPage = true;
            this.successLoadingClientEventsPage = false;

            // console.log(this.clientEventsObj.events[eventIndex]);

            try {
                const availabeTimeSlotsResponse = await this.getAvailableTimeSlots(eventIndex);

                // console.log(availabeTimeSlotsResponse);

                if (!availabeTimeSlotsResponse.status) {
                    if (availabeTimeSlotsResponse.invalidToken) {
                        this.$store.showErrorPopup = true;
                        this.$store.errorPopupTitle = 'logout';
                        this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                        this.$store.mustLogOut = true;
                    }
                    else {
                        this.popupObj = {
                            popupType: 'error',
                            title: 'unfortunately',
                            text: availabeTimeSlotsResponse.message,
                            actionBtn: false,
                        }
                        this.loadingPage = false;
                        this.successLoadingClientEventsPage = true;
                    }
                }
                else {
                    // console.log(availabeTimeSlotsResponse.data);
                    this.availabeTimeSlots = availabeTimeSlotsResponse.data;
                    // console.log("this.availabeTimeSlots: ");
                    // console.log(this.availabeTimeSlots);
                    this.selectedEvent = this.clientEventsObj.events[eventIndex];
                    // this.weeksRangeOfSelectedDate = this.getWeeksRangeOfSelectedDate(this.selectedEvent.Start_DateTime.slice(0, 10));
                    // console.log(this.weeksRangeOfSelectedDate);
                    this.weeksRangeOfSelectedDate = availabeTimeSlotsResponse.weeksPlanningPeriodRangeArr;
                    this.loadingPage = false;
                    this.showSelectedEventPage = true;
                    // this.successLoadingClientEventsPage = true;
                    // console.log(this.selectedEvent);
                }
            }

            catch(err) {
                console.log(err);
                this.loadingPage = false;
                this.successLoadingClientEventsPage = true;
            }
        },
        getAvailableTimeSlots: async function(eventIndex) {
            // console.log("this.availabeTimeSlots: ");
            // console.log(this.availabeTimeSlots);
            // if (!this.availabeTimeSlots || this.availabeTimeSlots.length == 0) {
            //     // this.popupObj = {
            //     //     popupType: 'warning',
            //     //     title: 'unfortunately',
            //     //     text: 'oops_try_again_or_contact_trainer',
            //     //     actionBtn: false,
            //     // };
            //     return {
            //         status: false,
            //         message: 'oops_try_again_or_contact_trainer',
            //     }
            // }
            // else {
            // }
            const localStorageUser = JSON.parse(localStorage.getItem('user'));
            if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
                return {
                    status: false,
                    expiredSession: true,
                    message: 'expired_session_try_to_login_again',
                }
            }
            else {
                try {
                    const { email, token } = localStorageUser;
                    // const clientEvents = this.clientEventsObj.events;
                    const selectedClientEvent = this.clientEventsObj.events[eventIndex];
                    
                    // console.log(eventIndex);
                    // console.log(selectedClientEvent);

                    // // Set the default value of the start date and time of the previuos and next session data as the same value in the selected event.
                    // let prevSessionDate = selectedClientEvent.Start_DateTime;
                    // let nextSessionDate = selectedClientEvent.Start_DateTime;

                    // if (clientEvents.length > 1) {
                    //     if (eventIndex < 1) {
                    //         if (this.startDateTimePrevNextSessions) {
                    //             prevSessionDate = this.startDateTimePrevNextSessions.startDateTimePreviousSession;
                    //         }
                    //         nextSessionDate = clientEvents[eventIndex + 1].Start_DateTime;
                    //     }
                    //     else if (eventIndex == clientEvents.length - 1) {
                    //         if (this.startDateTimePrevNextSessions) {
                    //             nextSessionDate = this.startDateTimePrevNextSessions.startDateTimeOf9thNextSession;
                    //         }
                    //         prevSessionDate = clientEvents[eventIndex - 1].Start_DateTime;
                    //     }
                    //     else {
                    //         prevSessionDate = clientEvents[eventIndex - 1].Start_DateTime;
                    //         nextSessionDate = clientEvents[eventIndex + 1].Start_DateTime;
                    //     }
                    // }
                    // else {
                    //     // The client has only one event. So set the next session date before 7 days (1 week ago).
                    //     prevSessionDate = this.getSpecificDate(nextSessionDate, -7);

                    //     // The client has only one event. So set the next session date after 7 days (1 week later).
                    //     nextSessionDate = this.getSpecificDate(nextSessionDate, 7);
                    // }

                    // console.log("prevSessionDate: " + prevSessionDate);
                    // console.log("nextSessionDate: " + nextSessionDate);

                    // console.log("this.prevSessionDate: " + this.prevSessionDate);
                    // console.log("this.nextSessionDate: " + this.nextSessionDate);

                    // this.clientEventsObj.startDateTimePrevNextSessions = {
                    //     startDateTimePreviousSession: prevSessionDate,
                    //     startDateTimeOf9thNextSession: nextSessionDate,
                    // }

                    // console.log(this.clientEventsObj);

                    let partnerEventId;

                    if (selectedClientEvent.Meeting_Type === 'DUO') {
                        if (this.clientEventsObj.partnerData) {
                            const partnerEvent = this.clientEventsObj.partnerData.events.find((partnerEvent) => partnerEvent.Start_DateTime == selectedClientEvent.Start_DateTime);
                            if (partnerEvent) {
                                partnerEventId = partnerEvent.id;
                            }
                        }
                    }

                    // console.log("partnerEventId: " + partnerEventId);

                    const data = {
                        email: email,
                        token: token,
                        eventId: selectedClientEvent.id,
                        zohoId: this.$store.user.zohoId,
                        studioTimeZone: this.$store.user.studiosInfo[0].studioTimeZone,
                        partnerEventId: partnerEventId,
                        // prevSessionDate: prevSessionDate,
                        // nextSessionDate: nextSessionDate
                    };

                    // console.log(data);

                    const getAvailableTimeSlotsResponse = await fetch('../../api/calendar/getAvailableTimes', {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json; charset=UTF-8',
                        },
                        body: JSON.stringify(data),
                    });

                    const getAvailableTimeSlotsResponseJson = await getAvailableTimeSlotsResponse.json();

                    // console.log("partnerEventId: " + this.partnerEventId);
                    // console.log(getAvailableTimeSlotsResponseJson);
                    // console.log(getAvailableTimeSlotsResponseJson);

                    return getAvailableTimeSlotsResponseJson;

                    // if (!getAvailableTimeSlotsResponseJson.status) {
                    //     this.$store.showErrorPopup = true;
                    //     this.$store.errorPopupTitle = 'action_failed';
                    //     this.$store.errorPopupMsg = getAvailableTimeSlotsResponseJson.message;
                    //     this.loadingPage = false;
                    //     this.successLoadingClientEventsPage = true;
                    // }
                    // else {
                    //     console.log(getAvailableTimeSlotsResponseJson.data.allAvailabletimeSlots);
                    //     this.selectedEventIndex = eventIndex;
                    //     this.availabeTimeSlots = getAvailableTimeSlotsResponseJson.data.allAvailabletimeSlots;
                    //     this.partnerEventId = getAvailableTimeSlotsResponseJson.data.partnerEventId;
                    //     this.successLoadingAvailableTileSlots = true;
                    //     this.loadingPage = false;
                    // }
                }
                catch(err) {
                    console.log("Error getting available time slots...");
                    return {
                        status: false,
                        message: 'action_failed',
                    }
                }
            }
        },
        goBack: function () {
            if (this.showSelectedEventPage) {
                if (this.showSaveBtn) {
                    this.popupObj = {
                        popupType: 'confirm',
                        title: 'not_saved',
                        text: 'continue_without_save',
                        actionBtn: () => {
                            this.showSelectedEventPage = false;
                            this.successLoadingClientEventsPage = true;
                            this.showSaveBtn = false;
                            this.popupObj = null;
                        },
                    };
                }
                else {
                    this.showSelectedEventPage = false;
                    this.successLoadingClientEventsPage = true;
                    // if (this.selectedEvent.Meeting_Type === 'DUO' && this.selectedEvent.Cancelled && this.IsPartnerEventActive) {
                    //     // this.selectedEventIndex = null;
                    //     // console.log("It's true");
                    // }
                }
            }
            else {
                this.$router.push("/home");
                this.$store.activeNavBarButton = 'home';
            }
        },
        toggoleDisplayingSaveBtnHandle: function (newStatus) {
            if (!newStatus) {
                this.showSaveBtn = false;
            }
            else {
                if (this.showSaveBtn == false) {
                    this.showSaveBtn = true;
                    // console.log(this.showSaveBtn);
                }
            }
        },
        updatePopupMsgObj: function (newPopupMsgObj) {
            this.popupObj = newPopupMsgObj;
        },
        updateCancellationReason: function (newCancellationReasonObj) {
            this.cancellationReasonObj = newCancellationReasonObj;
            if (this.cancellationReasonObj && this.cancellationReasonObj.reason && this.noCancellationReasonSelected) {
                this.noCancellationReasonSelected = false;
            }
        },
        updateRescheduleEventDataObject: function (newObjData) {
            this.rescheduleEventData = newObjData;
            // console.log(this.rescheduleEventData);
        },
        getSpecificDate: function(enteredDate, numberOfDays) {
            const date = new Date(enteredDate);
            date.setDate(date.getDate() + numberOfDays);

            // Helper to format the date
            const pad = (num) => String(num).padStart(2, '0');

            // Get local offset at the target date (approximation)
            const getOffset = (date) => {
                const offsetMinutes = -date.getTimezoneOffset();
                const hours = Math.floor(Math.abs(offsetMinutes) / 60);
                const minutes = Math.abs(offsetMinutes) % 60;
                const sign = offsetMinutes >= 0 ? '+' : '-';
                return `${sign}${pad(hours)}:${pad(minutes)}`;
            };

            // Format the date
            const year = date.getFullYear();
            const month = pad(date.getMonth() + 1);
            const day = pad(date.getDate());
            const hours = pad(date.getHours());
            const minutes = pad(date.getMinutes());
            const seconds = pad(date.getSeconds());
            const offset = getOffset(date);

            const result = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offset}`;

            return result;
        }
        








        // getWeeksRangeOfSelectedDate: function (dateString) {
        //     // Get the app language.
        //     const selectedAppLanguage = this.$store.selectedAppLanguage;

        //     const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
        //     const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        //     const monthNamesDutch = ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'];
        
        //     const givenDate = new Date(dateString);
        
        //     // Helper function to get the start date of the week (Monday) for a given date
        //     function getMonday(d) {
        //         const date = new Date(d);
        //         const day = date.getDay();
        //         const diff = (day === 0 ? -6 : 1) - day; // adjust when day is Sunday
        //         date.setDate(date.getDate() + diff);
        //         return date;
        //     }
        
        //     // Helper function to format the date as "YYYY-MM-DD"
        //     function formatDate(date) {
        //         const year = date.getFullYear();
        //         const month = String(date.getMonth() + 1).padStart(2, '0');
        //         const day = String(date.getDate()).padStart(2, '0');
        //         return `${year}-${month}-${day}`;
        //     }
        
        //     // Helper function to get the week's data for a given date
        //     function getWeekData(date) {
        //         const startOfWeek = getMonday(date);
        //         const weekData = [];
            
        //         for (let i = 0; i < 7; i++) {
        //             const currentDay = new Date(startOfWeek);
        //             currentDay.setDate(startOfWeek.getDate() + i);
        //             weekData.push({
        //             dayName: daysOfWeek[i],
        //             dayNumber: currentDay.getDate(),
        //             month: selectedAppLanguage === 'nl' ? monthNamesDutch[currentDay.getMonth()] : monthNames[currentDay.getMonth()],
        //             fullDate: formatDate(currentDay),
        //             });
        //         }
            
        //         return weekData;
        //     }
        
        //     // Get the number of the week for the given date
        //     function getWeekNumber(date) {
        //         const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
        //         const pastDaysOfYear = (date - firstDayOfYear) / 86400000;
        //         return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
        //     }
        
        //     // Calculate previous, current, and next week data
        //     const currentWeek = getWeekData(givenDate);
        //     const previousWeek = getWeekData(new Date(givenDate.setDate(givenDate.getDate() - 7)));
        //     const nextWeek = getWeekData(new Date(givenDate.setDate(givenDate.getDate() + 14)));
        
        //     // Get the week number for the given date
        //     const weekNumber = getWeekNumber(givenDate);
        
        //     return [
        //         { weekNumber: weekNumber - 1, weekDates: previousWeek },
        //         { weekNumber: weekNumber, weekDates: currentWeek },
        //         { weekNumber: weekNumber + 1, weekDates: nextWeek },
        //     ];
        // },
        // selectEvent: async function(eventIndex) {
        //     try {
        //         this.loadingPage = true;
        //         this.successLoadingClientEventsPage = false;
        //         this.selectedEvent = this.clientEvents[eventIndex];
        //         this.weeksRangeOfSelectedDate = this.getWeeksRangeOfSelectedDate(this.clientEvents[eventIndex].Start_DateTime.slice(0, 10));
        //         // console.log(this.weeksRangeOfSelectedDate);
        //         // console.log(this.clientEvents[eventIndex].Start_DateTime.slice(0, 10));

        //         const getAvailableTimeSlotsResponse = await this.getAvailableTimeSlots(eventIndex);

        //         if (!getAvailableTimeSlotsResponse.status) {
        //             if (getAvailableTimeSlotsResponse.expiredSession) {
        //                 this.$store.showErrorPopup = true;
        //                 this.$store.errorPopupTitle = 'logout';
        //                 this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
        //                 this.$store.mustLogOut = true;
        //             }
        //             else {
        //                 this.successLoadingClientEventsPage = true;
        //                 this.$store.showErrorPopup = true;
        //                 this.$store.errorPopupTitle = 'action_failed';
        //                 this.$store.errorPopupMsg = getAvailableTimeSlotsResponse.message;
        //                 this.loadingPage = false;
        //             }
        //         }
        //         else {
        //             console.log(getAvailableTimeSlotsResponse.data);
        //             this.availabeTimeSlots = getAvailableTimeSlotsResponse.data.allAvailabletimeSlots;
        //             this.loadingPage = false;
        //             this.successLoadingClientEventsPage = false;
        //             this.selectedEventIndex = eventIndex;
        //         }
        //     }
        //     catch(err) {
        //         console.log("Error selecting event...");
        //         this.successLoadingClientEventsPage = true;
        //         this.$store.showErrorPopup = true;
        //         this.$store.errorPopupTitle = 'action_failed';
        //         this.$store.errorPopupMsg = 'something_went_wrong_try_again';
        //         this.loadingPage = false;
        //     }
        // },
        // showConfirmPopupMsgHandle: function(eventActionType, selectedItemIndex, selectedItemGroupIndex) {
        //     let selectedEventInfo;
        //     // console.log("selectedItemIndex: " + selectedItemIndex);

        //     if (eventActionType === 'delete') {
        //         const eventDayName = this.clientEvents[selectedItemIndex].dateInfo.dayName;
        //         const eventDate = this.extractDate(this.clientEvents[selectedItemIndex].Start_DateTime);
        //         const eventStartTime = this.extractTimeFromDate(this.clientEvents[selectedItemIndex].Start_DateTime);
        //         const eventEndTime = this.extractTimeFromDate(this.clientEvents[selectedItemIndex].End_DateTime);
        //         selectedEventInfo = {
        //             "Date": `${eventDayName} ${eventDate}`,
        //             "Time": `${eventStartTime} - ${eventEndTime}`,
        //         }
        //     }
        //     else if (eventActionType === 'reschedule') {
        //         // console.log(eventActionType);
        //         // console.log(this.clientEvents[this.selectedEventIndex]);
        //         const currentEventDayName = this.clientEvents[this.selectedEventIndex].dateInfo.dayName;
        //         const currentEventDate = this.extractDate(this.clientEvents[this.selectedEventIndex].Start_DateTime);
        //         const currentEventStartTime = this.extractTimeFromDate(this.clientEvents[this.selectedEventIndex].Start_DateTime);
        //         const currentEventEndTime = this.extractTimeFromDate(this.clientEvents[this.selectedEventIndex].End_DateTime);

        //         console.log(this.availabeTimeSlots[selectedItemGroupIndex]);

        //         const newEventDayName = this.availabeTimeSlots[selectedItemGroupIndex].day_name;
        //         const newEventDate = this.availabeTimeSlots[selectedItemGroupIndex].date;
        //         const newEventStartTime = this.extractTimeFromDate(this.availabeTimeSlots[selectedItemGroupIndex].availableSlots[selectedItemIndex].Start_DateTime);
        //         const newEventEndTime = this.extractTimeFromDate(this.availabeTimeSlots[selectedItemGroupIndex].availableSlots[selectedItemIndex].End_DateTime);
        //         selectedEventInfo = {
        //             "Current Date": `${currentEventDayName} ${currentEventDate}`,
        //             "Current Time": `${currentEventStartTime} - ${currentEventEndTime}`,
        //             "New Date": `${newEventDayName} ${newEventDate}`,
        //             "New Time": `${newEventStartTime} - ${newEventEndTime}`,
        //         }
        //     }

        //     // console.log(selectedEventInfo);
            
        //     this.selectedEventInfo = selectedEventInfo;
        //     this.eventActionType = eventActionType;
        //     this.showConfirmPopupMsg = true;
        // },
        // closeConfirmPopupMsgHandle: function() {
        //     if (this.eventActionType === 'reschedule') {
        //         this.getClientEvents();
        //         this.successLoadingAvailableTileSlots = false;
        //         this.successLoadingClientEventsPage = true;
        //         this.selectedTimeSlotIndex = null;
        //         this.selectedTimeSlotGroupIndex = null;

        //         this.eventActionType = '';
        //         this.selectedEventInfo = false;
        //         this.showConfirmPopupMsg = false;
        //         this.loadingEventAction = false;
        //         this.showEventActionMsg = false;
        //         this.eventActionMsg = '';
        //         this.selectedEventIndex = null;
        //     }
        //     else {
        //         this.eventActionType = '';
        //         this.selectedEventInfo = false;
        //         this.showConfirmPopupMsg = false;
        //         this.loadingEventAction = false;
        //         this.showEventActionMsg = false;
        //         this.eventActionMsg = '';
        //         this.selectedEventIndex = null;
        //     }
        //     // this.eventActionType = '';
        //     // this.selectedEventInfo = false;
        //     // this.showConfirmPopupMsg = false;
        //     // this.loadingEventAction = false;
        //     // this.showEventActionMsg = false;
        //     // this.eventActionMsg = '';
        //     // this.selectedEventIndex = null;
            
        // },
        // deleteEvent: async function(eventIndex) {
        //     // console.log(eventIndex);
        //     this.loadingEventAction = true;
        //     const localStorageUser = JSON.parse(localStorage.getItem('user'));
        //     if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
        //         this.$store.showErrorPopup = true;
        //         this.$store.errorPopupTitle = 'logout';
        //         this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
        //         this.$store.mustLogOut = true;
        //     }
        //     else {
        //         try {
        //             const { email, token } = localStorageUser;
        //             const eventId = this.clientEvents[eventIndex].id;
        //             const data = {
        //                 email: email,
        //                 token: token,
        //                 eventId: eventId,
        //             };

        //             const deleteEventResponse = await fetch('../../api/calendar/deleteEvent', {
        //                 method: 'POST',
        //                 headers: {
        //                     'Accept': 'application/json',
        //                     'Content-Type': 'application/json; charset=UTF-8',
        //                 },
        //                 body: JSON.stringify(data),
        //             });

        //             const deleteEventResponseJson = await deleteEventResponse.json();

        //             if (!deleteEventResponseJson.status) {
        //                 // console.log("Can not delete the event!");
        //                 // console.log(deleteEventResponseJson.message);
        //                 this.msgColor = 'red';
        //                 this.eventActionMsg = deleteEventResponseJson.message;
        //             }
        //             else {
        //                 this.clientEvents[eventIndex].Cancelled = true;
        //                 this.msgColor = 'green';
        //                 this.eventActionMsg = 'Event has been deleted successfully'
        //             }

        //             this.showEventActionMsg = true;
        //         }
        //         catch(err) {
        //             console.log("Error deleting event...");
        //             console.log(err);
        //             this.showEventActionMsg = true;
        //             this.msgColor = 'red';
        //             this.eventActionMsg = 'Something went wrong! Try Again.'
        //         }
        //     }
        // },
        // getAvailableTimeSlots: async function(eventIndex) {
        //     const localStorageUser = JSON.parse(localStorage.getItem('user'));
        //     if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
        //         // this.$store.showErrorPopup = true;
        //         // this.$store.errorPopupTitle = 'logout';
        //         // this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
        //         // this.$store.mustLogOut = true;
        //         return {
        //             status: false,
        //             expiredSession: true,
        //             message: 'expired_session_try_to_login_again',
        //         }
        //     }
        //     else {
        //         try {
        //             const { email, token } = localStorageUser;
        //             const eventObj = this.clientEvents[eventIndex];
        //             let prevSessionDate = this.clientEvents[eventIndex].Start_DateTime;
        //             let nextSessionDate = this.clientEvents[eventIndex].Start_DateTime;

        //             if (eventIndex < 1) {
        //                 if (!this.startDateTimePrevNextSessions) {
        //                     prevSessionDate = this.clientEvents[eventIndex].Start_DateTime;
        //                 }
        //                 else {
        //                     prevSessionDate = this.startDateTimePrevNextSessions.startDateTimePreviousSession;
        //                 }
        //                 nextSessionDate = this.clientEvents[eventIndex + 1].Start_DateTime;
        //             }
        //             else if (eventIndex == this.clientEvents.length - 1) {
        //                 if (!this.startDateTimePrevNextSessions) {
        //                     nextSessionDate = this.clientEvents[eventIndex + 1].Start_DateTime;
        //                 }
        //                 else {
        //                     nextSessionDate = this.startDateTimePrevNextSessions.startDateTimeOf9thNextSession;
        //                 }
        //                 prevSessionDate = this.clientEvents[eventIndex - 1].Start_DateTime;
        //             }
        //             else {
        //                 prevSessionDate = this.clientEvents[eventIndex - 1].Start_DateTime;
        //                 nextSessionDate = this.clientEvents[eventIndex + 1].Start_DateTime;
        //             }

        //             // console.log("prevSessionDate: " + prevSessionDate);
        //             // console.log("nextSessionDate: " + nextSessionDate);
                    

        //             const data = {
        //                 email: email,
        //                 token: token,
        //                 eventId: eventObj.id,
        //                 eventObj: eventObj,
        //                 prevSessionDate: prevSessionDate,
        //                 nextSessionDate: nextSessionDate
        //             };

        //             // console.log(data);

        //             const getAvailableTimeSlotsResponse = await fetch('../../api/calendar/getAvailableTimes', {
        //                 method: 'POST',
        //                 headers: {
        //                     'Accept': 'application/json',
        //                     'Content-Type': 'application/json; charset=UTF-8',
        //                 },
        //                 body: JSON.stringify(data),
        //             });

        //             const getAvailableTimeSlotsResponseJson = await getAvailableTimeSlotsResponse.json();

        //             return getAvailableTimeSlotsResponseJson;

        //             // if (!getAvailableTimeSlotsResponseJson.status) {
        //             //     this.$store.showErrorPopup = true;
        //             //     this.$store.errorPopupTitle = 'action_failed';
        //             //     this.$store.errorPopupMsg = getAvailableTimeSlotsResponseJson.message;
        //             //     this.loadingPage = false;
        //             //     this.successLoadingClientEventsPage = true;
        //             // }
        //             // else {
        //             //     console.log(getAvailableTimeSlotsResponseJson.data.allAvailabletimeSlots);
        //             //     this.selectedEventIndex = eventIndex;
        //             //     this.availabeTimeSlots = getAvailableTimeSlotsResponseJson.data.allAvailabletimeSlots;
        //             //     this.partnerEventId = getAvailableTimeSlotsResponseJson.data.partnerEventId;
        //             //     this.successLoadingAvailableTileSlots = true;
        //             //     this.loadingPage = false;
        //             // }
        //         }
        //         catch(err) {
        //             console.log("Error getting available time slots...");
        //             return {
        //                 status: false,
        //                 message: 'action_failed',
        //             }
        //         }
        //     }
        // },
        // backToAppointmentsPage: function() {
        //     this.availabeTimeSlots = [];
        //     this.successLoadingAvailableTileSlots = false;
        //     this.successLoadingClientEventsPage = true;
        // },
        // selectTimeSlot: function(timeSlotGroupIndex, timeSlotIndex) {
        //     console.log(timeSlotIndex);
        //     this.selectedTimeSlotGroupIndex = timeSlotGroupIndex;
        //     this.selectedTimeSlotIndex = timeSlotIndex;
        //     console.log(this.selectedTimeSlotIndex);
        // },
        // rescheduleEvent: async function() {
        //     console.log("Rescheduling...");
        //     this.loadingEventAction = true;
        //     const localStorageUser = JSON.parse(localStorage.getItem('user'));
        //     if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
        //         this.$store.showErrorPopup = true;
        //         this.$store.errorPopupTitle = 'logout';
        //         this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
        //         this.$store.mustLogOut = true;
        //     }
        //     else {
        //         try {
        //             const { email, token } = localStorageUser;
        //             const ownerEventId = this.clientEvents[this.selectedEventIndex].id;
        //             const newStartDateTime = this.availabeTimeSlots[this.selectedTimeSlotGroupIndex].availableSlots[this.selectedTimeSlotIndex].Start_DateTime;
        //             const newEndDateTime = this.availabeTimeSlots[this.selectedTimeSlotGroupIndex].availableSlots[this.selectedTimeSlotIndex].End_DateTime;
        //             const partnerEventId = this.partnerEventId;

        //             const data = {
        //                 email: email,
        //                 token: token,
        //                 ownerEventId: ownerEventId,
        //                 newStartDateTime: newStartDateTime,
        //                 newEndDateTime: newEndDateTime,
        //                 partnerEventId: partnerEventId,
        //             }

        //             const rescheduleEventResponse = await fetch('../../api/calendar/rescheduleEvent', {
        //                 method: 'POST',
        //                 headers: {
        //                     'Accept': 'application/json',
        //                     'Content-Type': 'application/json; charset=UTF-8',
        //                 },
        //                 body: JSON.stringify(data),
        //             });

        //             const rescheduleEventResponseJson = await rescheduleEventResponse.json();

        //             if (!rescheduleEventResponseJson.status) {
        //                 this.msgColor = 'red';
        //                 this.eventActionMsg = rescheduleEventResponseJson.message;
        //             }
        //             else {
        //                 this.msgColor = 'green';
        //                 this.eventActionMsg = "Event has been rescheduled successfully";
        //             }

        //             this.showEventActionMsg = true;
        //         }
        //         catch(err) {
        //             console.log("Error rescheduling event...");
        //             console.log(err);
        //             this.showEventActionMsg = true;
        //             this.msgColor = 'red';
        //             this.eventActionMsg = 'something_went_wrong_try_again';
        //         }
        //     }
        // }
    },
    async created() {
        // console.log(this.$store.user);
        // window.addEventListener('message', this.handleMessage);
        try {
            if (!this.$store.user.zohoId) {
                const localStorageUser = JSON.parse(localStorage.getItem('user'));
                if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
                    this.$store.showErrorPopup = true;
                    this.$store.errorPopupTitle = 'logout';
                    this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                    this.$store.mustLogOut = true;
                }
                else {
                    const { email, token } = localStorageUser;
                    const userAuth = await this.$store.authUser(email, token);
                    if (!userAuth.status) {
                        if (userAuth.confirmWarning) {
                            this.$store.unconfirmedAccount = true;
                            this.$store.showFooterBackBtn = true;
                            this.$store.user.email = email;
                            this.$router.push('/confirm');
                        }
                        else if (userAuth.error) {
                            this.$store.showMainErrorPage = true;
                        }
                        else {
                            this.$store.showErrorPopup = true;
                            this.$store.errorPopupTitle = 'logout';
                            this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                            this.$store.mustLogOut = true;
                        }
                    }
                    else {
                        await this.getClientEvents();
                    }
                }
            }
            else {
                if (!this.clientEventsObj || this.clientEventsObj.events.length == 0) {
                    await this.getClientEvents();

                }
                else {
                    this.loadingPage = false;
                    this.successLoadingClientEventsPage = true;
                }
            }
        }
        catch(err) {
            console.log(err);
            this.failedLoadingPage = true;
            this.loadingPage = false;
            this.popupObj = null;
            // this.failedLoadingPage = true;
            // this.loadingPage = false;
            // this.$store.showMainErrorPage = true;
        }
    },
    beforeDestroy() {
        // window.removeEventListener('message', this.handleMessage);
    }
}
</script>

<style>

    .scheduling-home-page-component-container {
        position: relative;
        height: 100vh;
        width: 100%;
    }

    .scheduling-home-page-component-container .component-wrapper {
        height: 100vh;
        display: flex;
        flex-direction: column;
    }

    .scheduling-home-page-component-container .scheduling-home-page-container {
        flex: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        /* justify-content: center; */
        align-items: center;
        overflow: auto;
        padding-bottom: 30px;
    }

    .scheduling-home-page-component-container .spinner-container {
        flex: 1;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .scheduling-home-page-component-container .spinner {
        width: 20% !important;
        max-width: 100px !important;
    }

    .scheduling-home-page-component-container .back-btn-info-btn-container {
        width: 100%;
        /* height: 50px; */
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 25px;
    }

    .scheduling-home-page-component-container .back-btn-container {
        width: 40px;
        /* height: 100%; */
        display: flex;
        flex-direction: column;
        justify-content: center;
        cursor: pointer;
    }

    .scheduling-home-page-component-container .back-btn-container img {
        width: 100%;
    }

    [dir="rtl"] .scheduling-home-page-component-container .back-btn-container img {
        transform: rotate(180deg);
    }

    .scheduling-home-page-component-container .info-btn-container {
        width: 32px;
        /* height: 100%; */
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 3px;
        cursor: pointer;
    }

    .scheduling-home-page-component-container .info-btn-container img {
        width: 100%;
    }

    [dir="rtl"] .scheduling-home-page-component-container .info-btn-container img {
        transform: scaleX(-1);
    }

    .scheduling-home-page-component-container .info-text-container {
        width: 100%;
        max-width: 475px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 5% 0 25px;
        /* border: 1px solid red; */
    }

    .scheduling-home-page-component-container .info-text-container .info-text {
        font-size: 30px;
        font-family: 'VAG Rounded Std', sans-serif;
        color: #a0a1a3;
        text-align: center;
        line-height: 35px;
        /* border: 1px solid red; */
    }

    .scheduling-home-page-component-container .events-list {
        width: 100%;
        /* max-width: 500px; */
        display: flex;
        /* flex-direction: column; */
        justify-content: space-evenly;
        /* align-items: center; */
        flex-wrap: wrap;
        /* border: 1px solid; */
    }

    /* .scheduling-home-page-component-container .event-container {
        width: 45%;
        display: flex;
        flex-direction: column;
        align-items: center;
    } */

    .scheduling-home-page-component-container .event-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 10px 0 5px;
        padding: 5px 0;
        border-radius: 20px;
        cursor: pointer;
    }

    /* .scheduling-home-page-component-container .normal-event {
        color: #92d400;
        border: 2px solid #92d400;
    }

    .scheduling-home-page-component-container .normal-event:hover {
        color: #fff;
        background: #92d400;
    }

    .scheduling-home-page-component-container .rescheduled-event {
        color: #009df4;
        border: 2px solid #009df4;
    } */

    /* .scheduling-home-page-component-container .rescheduled-event:hover {
        color: #fff;
        background: #009df4;
    } */

    /* .scheduling-home-page-component-container .cancelled-event {
        color: #fff;
        background: #616365;
    } */

    .scheduling-home-page-component-container .event-info {
        font-size: 24px;
        font-family: 'VAG Rounded Std', sans-serif;
        padding: 4px 0 2px;
    }

    .scheduling-home-page-component-container .event-options-container {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .scheduling-home-page-component-container .event-options-list {
        width: 100%;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
    }

    .scheduling-home-page-component-container .event-option {
        width: 48%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
        font-family: 'VAG Rounded Std', sans-serif;
        color: #fff;
        cursor: pointer;
        padding: 15px 0;
        border-radius: 30px;
        border: 1px solid;
    }

    .scheduling-home-page-component-container .cancel-event {
        background: #cb061d;
    }

    .scheduling-home-page-component-container .reschedule-event {
        background: #009df4;
    }

    .scheduling-home-page-component-container .event-action-msg-container {
        padding: 5px 0;
    }

    .scheduling-home-page-component-container .event-action-msg {
        font-size: 18px;
        font-family: 'VAG Rounded Std', sans-serif;
    }

    .scheduling-home-page-component-container .available-time-slots-container {
        position: relative;
        flex: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .scheduling-home-page-component-container .available-time-slots-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        /* border: 1px solid; */
    }

    .scheduling-home-page-component-container .avialable-time-slots-list {
        width: 100%;
        display: flex;
        justify-content: space-evenly;
        flex-wrap: wrap;
        padding: 0 10px;
        /* border: 1px solid; */
    }

    .scheduling-home-page-component-container .avialable-time-slots-container {
        width: 48%;
        display: flex;
        flex-direction: column;
        align-items: center;
        border: 2px solid #009df4;
        border-radius: 10px;
        /* background: #92d400; */
        margin: 5px;
    }

    .scheduling-home-page-component-container .day-info-container {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 20px 0;
        background: #009df4;
        border-radius: 8px 8px 0 0;
    }

    .scheduling-home-page-component-container .day-name {
        padding-right: 10px;
    }

    .scheduling-home-page-component-container .day-date {
        padding-left: 10px;
    }

    .scheduling-home-page-component-container .day-name, .scheduling-home-page-component-container .day-date {
        font-size: 28px;
        color: #fff;
        font-family: 'VAG Rounded Std', sans-serif;
    }

    .scheduling-home-page-component-container .day-available-time-slots-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .scheduling-home-page-component-container .day-available-time-slots-list {
        width: 100%;
        display: flex;
        justify-content: center;
        /* align-items: center; */
        flex-wrap: wrap;
        padding: 10px 0;
        /* border: 1px solid; */
    }

    .scheduling-home-page-component-container .day-available-time-slot-item-container {
        width: 20%;
        margin: 5px;
        display: flex;
        flex-direction: column;
        /* justify-content: center; */
        align-items: center;
    }

    .scheduling-home-page-component-container .day-available-time-solt-container {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        font-size: 18px;
        color: #92d400;
        font-family: 'VAG Rounded Std', sans-serif;
        padding: 10px;
        margin-bottom: 5px;
        border: 2px solid #92d400;
    }

    .scheduling-home-page-component-container .day-available-time-solt-container:hover {
        background-color: #92d400;
        color: #fff;
        cursor: pointer;
    }

    .scheduling-home-page-component-container .time-slot-confirm-btn-container {
        width: 90%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-family: 'VAG Rounded Std', sans-serif;
        color: #fff;
        cursor: pointer;
        padding: 8px 0;
        border-radius: 30px;
        border: 1px solid;
        background: #009df4;
    }

    .scheduling-home-page-component-container .no-available-time-slots-msg-container {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .scheduling-home-page-component-container .no-available-time-slots-msg-container p {
        font-size: 30px;
        font-family: 'VAG Rounded Std', sans-serif;
        color: #a0a1a3;
        text-align: center;
        line-height: 35px;
    }

    .scheduling-home-page-component-container .back-to-appointments-btn-container {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 20px;
        /* border: 1px solid; */
    }

    .scheduling-home-page-component-container .back-to-appointments-btn-wrapper {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .scheduling-home-page-component-container .back-arrow-img-container {
        width: 15px;
        display: flex;
        /* justify-content: center; */
        align-items: center;
        margin-right: 5px;
        /* border: 1px solid; */
    }

    .scheduling-home-page-component-container .text-container p {
        color: #009df4;
        font-family: 'Open Sans Std', sans-serif;
        font-size: 18px;
    }

    .scheduling-home-page-component-container .back-arrow-img-container img {
        width: 100%;
    }

    .scheduling-home-page-component-container .fit20-logo-wrapper {
        height: 100%;
        max-height: 105px;
        margin-bottom: -6px;
        /* border: 1px solid blue; */
    }

    .scheduling-home-page-component-container .fialed-loading-page-container {
        flex: 1;
        width: 100%;
        max-width: 500px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .scheduling-home-page-component-container .reload-btn-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-family: 'Open Sans Std', sans-serif;
        /* border: 1px solid red; */
    }

    .scheduling-home-page-component-container .reload-btn {
        width: 50%;
        min-width: 200px;
        color: #fff;
        font-family: 'VAG Rounded Std', sans-serif;
        font-size: 24px;
        text-align: center;
        letter-spacing: 1px;
        padding: 6px 0 10px;
        background: #009df4;
        border: 1px solid #fff;
        border-radius: 30px;
        cursor: pointer;
    }

    @media (max-width: 426px) {
        .scheduling-home-page-component-container .reload-btn {
            font-size: 24px;
        }
    }
</style>